"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.symbol.description");

require("core-js/modules/es.symbol.iterator");

require("core-js/modules/es.array.concat");

require("core-js/modules/es.array.from");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.array.map");

require("core-js/modules/es.array.slice");

require("core-js/modules/es.function.name");

require("core-js/modules/es.object.get-prototype-of");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.reflect.construct");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.string.iterator");

require("core-js/modules/web.dom-collections.iterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CustomErrorPositions = void 0;

var _react = _interopRequireDefault(require("react"));

var _mobxReact = require("mobx-react");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _scrollToElement = _interopRequireDefault(require("scroll-to-element"));

var _Message = _interopRequireDefault(require("@icare/components/lib/Message"));

var _Button = _interopRequireDefault(require("@icare/components/lib/Button"));

var _FormUtils = _interopRequireDefault(require("../../utils/FormUtils"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var CustomErrorPositions = {
  BEFORE: 'before',
  AFTER: 'after'
};
exports.CustomErrorPositions = CustomErrorPositions;
var _id = 0;

var FormErrorSummary = /*#__PURE__*/function (_React$Component) {
  _inherits(FormErrorSummary, _React$Component);

  var _super = _createSuper(FormErrorSummary);

  function FormErrorSummary(props) {
    var _this;

    _classCallCheck(this, FormErrorSummary);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_scrollToElement", function (ele) {
      (0, _scrollToElement.default)(ele, {
        offset: _this.props.scrollOffsetTop * -1,
        duration: 500
      });
    });

    _defineProperty(_assertThisInitialized(_this), "_handleOnClick", function (fieldName) {
      _this._scrollToElement("[for='".concat(fieldName, "']"));
    });

    _this._id = _id;
    _id = _id + 1;
    return _this;
  }

  _createClass(FormErrorSummary, [{
    key: "renderErrorList",
    value: function renderErrorList(fieldsWithErrors) {
      var _this2 = this;

      var _this$props = this.props,
          customErrors = _this$props.customErrors,
          customErrorsPosition = _this$props.customErrorsPosition;
      var items = fieldsWithErrors.map(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            field = _ref2[1];

        return /*#__PURE__*/_react.default.createElement("li", {
          key: field.id
        }, /*#__PURE__*/_react.default.createElement(_Button.default, {
          tag: "a",
          href: "#".concat(field.id),
          variant: _Button.default.Variant.LINK,
          onClick: function onClick() {
            return _this2._handleOnClick(field.id);
          }
        }, /*#__PURE__*/_react.default.createElement("strong", null, field.label, ":"), " ", field.error));
      });
      var customItems = (customErrors || []).map(function (message, i) {
        return /*#__PURE__*/_react.default.createElement("li", {
          key: i
        }, message);
      });
      return /*#__PURE__*/_react.default.createElement("ul", {
        key: items.length
      }, customErrorsPosition === CustomErrorPositions.BEFORE && customItems, items, customErrorsPosition === CustomErrorPositions.AFTER && customItems);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          form = _this$props2.form,
          validateAfterSubmit = _this$props2.validateAfterSubmit,
          customErrors = _this$props2.customErrors;

      var fieldsWithErrors = _FormUtils.default.mapFormErrors(form).concat(customErrors);

      if (form.hasChanged && !fieldsWithErrors.length) {
        form.setFormSubmitted(false);
      } // Only show errors if form has been submitted and has validateAfterSubmit props;


      if (!fieldsWithErrors.length || validateAfterSubmit && !form.hasBeenSubmitted) {
        return null;
      }

      return /*#__PURE__*/_react.default.createElement(_Message.default, {
        id: "FormErrorSummary".concat(this._id),
        type: _Message.default.type.ERROR,
        title: "There are some validation issues."
      }, /*#__PURE__*/_react.default.createElement("p", null, "The following ", fieldsWithErrors.length, " fields contain errors:"), this.renderErrorList(fieldsWithErrors));
    }
  }]);

  return FormErrorSummary;
}(_react.default.Component);

_defineProperty(FormErrorSummary, "propTypes", {
  form: _propTypes.default.object.isRequired,
  customErrors: _propTypes.default.arrayOf(_propTypes.default.node),
  customErrorsPosition: _propTypes.default.string,
  validateAfterSubmit: _propTypes.default.bool,
  //scrollingElement: T.object,
  // focus will be this amount of pixels above the field label
  scrollOffsetTop: _propTypes.default.number
});

_defineProperty(FormErrorSummary, "defaultProps", {
  customErrors: [],
  customErrorsPosition: CustomErrorPositions.BEFORE,
  validateAfterSubmit: null,
  //scrollingElement: window,
  scrollOffsetTop: 107
});

var _default = (0, _mobxReact.observer)(FormErrorSummary);

exports.default = _default;
//# sourceMappingURL=FormErrorSummary.js.map